module.exports = __webpack_public_path__ + "img/caroselPause.65f9ea32.svg";